import CustomCssParser from '../model/CustomCssParser';

export default {
  textTags: ['br', 'b', 'i', 'u', 'a', 'ul', 'ol'],

  // Custom CSS parser
  parserCss: CustomCssParser,

  // Custom HTML parser
  parserHtml: null
};
